import type { CurrentUserData } from 'hooks/api/use-current-user';

export const canAccessCriticalPopulations = (
  user: Pick<CurrentUserData, 'admin'> | null | undefined,
  featureFlags: Record<string, boolean> | undefined
): boolean => !!featureFlags?.['critical-populations'] && !!user?.admin;
